/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as AlertIcon } from "../../../../../assets/Icons/IconNotifications.svg";
import { ReactComponent as CartIcon } from "../../../../../assets/Icons/IconCart.svg";
import { ReactComponent as SearchIcon } from "../../../../../assets/Icons/IconsSearch.svg";
import GenericDropdown from "@ui-components/Dropdown/GenericDropdown";
import {
  loadSavedOrder,
  Order,
  setCurrentStep,
} from "@redux/slices/kontrolEdge/orderSlice";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { getSaveOrder } from "../../../request/request";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppDispatch } from "@redux/hooks";
import { fetchAlertsList } from "settings/account/components/Notifications/requests/request";
import { useAxiosAuth0 } from "@shared/config/useAxiosAuth0";
import { AlertItem } from "settings/account/components/Notifications/NotificationTypes";


export const KontrolMenu = ({ tenantType }: { tenantType: string | null }) => {
  // const location = useLocation();
  const api = useAxiosAuth0();
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState<Order[]>([]);
  //Alerts logic
  const [alertItems, setAlertItems] = useState<AlertItem[]>([]);
  const [hasSeenNotifications, setHasSeenNotifications] = useState(false);
  const [alertsCount, setAlertsCount] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const hasMarkedSeen = useRef(false);
  

  //Fetch alerts
  // useEffect(() => {
  //   const fetchAlertsData = async () => {
  //     try {
  //       const response = await fetchAlertsList(api);
  //       const events: any[] = response.data?.data?.alertEvents || [];
  

  //       // 2) map into your AlertItem shape
  //       const transformed: AlertItem[] = events.map(a => ({
  //         id:        a.id,
  //         alertName: a.alertName,
  //         description: a.description ?? 'No description',
  //         severity:    a.severity,
  //         createdAt:   new Date(a.createdAt).toLocaleString('en-US', {
  //           dateStyle: 'medium',
  //           timeStyle: 'short',
  //         }),
  //       }));

  //       // 3) Set totals + the first 5
  //       setAlertsCount(transformed.length);
  //       setHasMore(transformed.length > 4);
  //       setAlertItems(transformed.slice(0, 5));
  //     } catch (err) {
  //       console.error('Error fetching dropdown alerts:', err);
  //     }

  //   };
  
  //   fetchAlertsData();
  // }, [api]);

  useEffect(() => {
    if (isDropdownOpen && !hasMarkedSeen.current) {
      hasMarkedSeen.current = true;
      setHasSeenNotifications(true);
    }
  }, [isDropdownOpen])
  
  

  // Handler to drill into an alert
  const handleViewAlert = (alert: AlertItem) => {
    setHasSeenNotifications(true);
    navigate(`/kontrol/notifications-history`);
  };

  const transformOrders = (ordersFromApi: any[]): Order[] => {
    return ordersFromApi.map((order) => ({
      orderId: order.id,
      name: order.name,
      email: order.email,
      ports: order.data ?? [],
      locations: order.locations || [],
      currentStep: order.currentStep || 1,
      status: order.status || { current: "draft" },
    }));
  };

  const transformSavedOrder = (savedOrder: Order): Order => {
    return {
      orderId: savedOrder.orderId,
      name: savedOrder.name,
      email: savedOrder.email,
      ports: savedOrder.ports ?? [],
      locations: savedOrder.locations ?? [],
      currentStep: savedOrder.currentStep || 1,
      status: savedOrder.status || { current: "draft" },
      isEditing: true,
    };
  };

  // This function fetches the access token and then the orders from the API
  const fetchOrdersData = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await getSaveOrder(accessToken);
      const transformedOrders = transformOrders(response.data);
      setCartItems(transformedOrders);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  // useEffect(() => {
  //   fetchOrdersData();
  // }, []);

  const handleViewOrder = (savedOrder: Order) => {
    // Transform the saved order into the format expected by your Redux state
    const transformedOrder = transformSavedOrder(savedOrder);
    // Dispatch the action to load the saved order into the Redux store
    dispatch(loadSavedOrder(transformedOrder));
    // Set the current step to 4 (Order Overview)
    dispatch(setCurrentStep(4));
    // Redirect the user to the port creation flow at step 4
    navigate("/kontrol/add-port", {
      state: { order: transformedOrder, currentStep: 4 },
    });
  };

  const formatCrossConnect = (value: string) => {
    if (!value) return "";
    switch (value) {
      case "requireXC":
        return "Require cross connect";
      case "provideXC":
        return "Cross connect provided";
      case "lastMile":
        return "Last mile";
      default:
        return value;
    }
  };

  //This is for the navigation menu (Profile button section)
  const KontrolDropdowns = () => (
    <div className="flex items-center gap-4">
      {/* {tenantType === "GLOBAL_ADMIN" && ( */}
      {/* <GenericDropdown
        items={cartItems as unknown as string[]}
        defaultLabel=""
        icon={<CartIcon className="h-6 w-6 text-semantic-text-secondary" />}
        fetchOptions={fetchOrdersData}
        position="right"
        dropdownSubtitle="Saved Orders"
        emptyItemsMessage="No cart items to show"
        emptyIcon={<SearchIcon className="h-5 w-5" />}
        dropdownMaxWidthClass="w-[500px]"
        badgeProps={{
          type: "number",
          variant: "alert",
          number: cartItems.length,
        }}
        renderItem={(order: Order) => (
          <div
            key={order.orderId}
            className="p-5 m-2 border rounded-md border-gray-200"
          >
            <div className="flex justify-between items-center">
              <h4 className="font-semibold text-sm">{order.name}</h4>
              <GenericButton
                variant="secondary"
                shape="ghost"
                size="sm"
                label="View Order"
                onClick={() => handleViewOrder(order)}
              />
            </div>
            {order.ports?.map((port: any, index: number) => (
              <div
                key={`${order.orderId}-${index}`}
                className="my-2 pt-2 border-t border-gray-200"
              >
                <div className="flex justify-start space-x-2">
                  <GenericTag
                    size="small"
                    textColor="text-semantic-text-brand"
                    label={port.basicInfo?.name || "N/A"}
                    variant="neutral"
                  />
                  <GenericTag
                    size="small"
                    textColor="text-semantic-text-brand"
                    label={port.basicInfo?.tag || "N/A"}
                    variant="neutral"
                  />
                </div>
                <p className="text-sm">
                  {port.location?.facilityName || "N/A"}
                </p>
                <div className="flex">
                  <p className="text-sm">
                    {port.configuration?.capacity?.speed || "Unknow"},{" "}
                  </p>
                  <p className="text-sm">
                    {port.configuration?.capacity?.type
                      ? `${port.configuration?.capacity?.type} port`
                      : "Unknow"}
                    ,{" "}
                  </p>
                  <p className="text-sm">
                    term {port.configuration?.term?.months ?? "N/A"} months{" "}
                  </p>
                </div>
                <div className="flex">
                  {port.configuration?.vlan && (
                    <p className="text-sm">
                      {port.configuration.vlan
                        ? `VLAN ${port.configuration.vlan}`
                        : " "}
                      ,{" "}
                    </p>
                  )}
                  {port.configuration?.crossConnect && (
                    <p className="text-sm">
                      {port.configuration.crossConnect
                        ? `${formatCrossConnect(
                            port.configuration.crossConnect
                          )}`
                        : " "}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      /> */}
      {/* )} */}
      <GenericDropdown
        items={alertItems as unknown as string[]}
        defaultLabel=""
        icon={<AlertIcon className="h-6 w-6 text-semantic-text-secondary" />}
        position="right"
        dropdownSubtitle="Notifications"
        emptyItemsMessage="No notifications"
        emptyIcon={<SearchIcon className="h-5 w-5" />}
        dropdownMaxWidthClass="w-[400px]"
        badgeProps={
          hasSeenNotifications || alertsCount === 0
            ? undefined
            : {
                type: "number",
                variant: "alert",
                number: alertsCount,
              }
        }
        onOpenChange={(open) => setIsDropdownOpen(open)}
        renderItem={(alert: AlertItem) => (
          <div
            key={alert.id}
            className="
			p-5 m-2 
			border rounded-md bg-semantic-bg-primary
			hover:bg-semantic-bg-secondary
			cursor-pointer"
            onClick={() => handleViewAlert(alert)}
          >
            <div className="flex justify-between items-start">
              <div>
                <h4 className="font-semibold text-sm">{alert.alertName}</h4>
                <p className="text-xs text-semantic-text-secondary line-clamp-2">
                  {alert.description}
                </p>
              </div>
              <GenericTag
                size="small"
                rounded="full"
                variant={alert.severity === "critical" ? "error" : "neutral"}
                label={
                  alert.severity.charAt(0).toUpperCase() +
                  alert.severity.slice(1).toLowerCase()
                }
              />
            </div>
            <p className="text-[10px] text-gray-400 mt-1">{alert.createdAt}</p>
          </div>

        )}
		>
		{hasMore && (
		<div className="p-4 border-t text-center">
		<button
			onClick={() => {
        setHasSeenNotifications(true);
        navigate("/kontrol/notifications-history")
      }}
			className="text-sm text-semantic-text-brand hover:underline"
		>
			View More
		</button>
		</div>
	)}
	</GenericDropdown>
    </div>
  );

  return {
    KontrolDropdowns,
  };
};
